import {FC, useMemo} from "react";
import { ResolveFATServiceOrderSteps } from "components/forms";
import lodash from "lodash";


interface FactoryAcceptanceTestServiceOrderResolutionDetailsProps {
  resolution: any;
  result: string;
}

export const FactoryAcceptanceTestServiceOrderResolutionDetails: FC<
  FactoryAcceptanceTestServiceOrderResolutionDetailsProps
> = ({ resolution, result }) => {

  const fatData = useMemo(() => ({
    testInfo: {
      ...resolution.testInfo,
      representatives: resolution?.representatives,
    },
    productInfo: resolution?.productInfo,
    productCharacteristics: resolution?.productCharacteristics,
    test: resolution?.test,
    physicalInspection: resolution?.physicalInspection,
    factoryAssessment: resolution?.factoryAssessment,
    extraInfo: {
      observations: resolution.observations || [],
      conclusion: resolution.conclusion,
      recommendations: resolution.recommendations,
      supportingImageUrls: resolution.supportingImageUrls || [],
      routineTestReports: resolution.routineTestReports || [],
    }
  }), [resolution])

  return (
    <div className={"relative"}>
      <div className='absolute right-5 flex justify-start'>
        <img
          src={
            result === "Passed"
              ? "/passed-stamp.png"
              : "/failed-stamp.png"
          }
          className='h-24 '
          alt=''
        />
      </div>
      <div className='space-y-6  divide-y divide-gray-200 overflow-y-auto flex-1'>
        {ResolveFATServiceOrderSteps.map(({ SummaryComponent, ...summary }, idx: number) => (
          <div key={idx} className={idx === 0 ? " p-4" : " p-4 pt-6"}>
            <>
              <div className='flex justify-between items-center cursor-pointer'>
                <div>
                  <h3 className='text-md leading-6 font-normal text-gray-900 dark:text-gray-100'>
                    {summary.name}
                  </h3>
                  <p className='mt-1 text-xs text-gray-500'>
                    {summary.description}
                  </p>
                </div>
                <div />
              </div>
              <div className='mt-6'>
                <SummaryComponent
                  data={lodash.get(fatData, summary?.accessor)}
                  // @ts-ignore
                  values={resolution}
                />
              </div>
            </>
          </div>
        ))}
      </div>
    </div>
  );
};